export default __webpack_public_path__ + "static/media/team5@2x.ba4019a1.png";